import {toRaw} from 'vue';

export default class {

    static compareObjects(obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }

    static getByString(o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    }

    static cleanClone(obj) {
        return JSON.parse(JSON.stringify(toRaw(obj)));
    }

    static isObject(obj) {
        if (obj === null) { return false; }
        return ((typeof obj === 'function') || (typeof obj === 'object'));
    }

    /**
     * Return an object's property, or the fallback if it doesn't exist.
     *
     * @param {*} object
     * @param {string} path
     * @param {string} fallback
     */
    static optionalProperty(object, path, fallback = null) {
        let properties = path.split('.');
        for (let a = 0; a < properties.length; a += 1) {
            if (this.isObject(object) && object.hasOwnProperty(properties[a])) {
                object = object[properties[a]];
            } else {
                return fallback;
            }
        }
        return object;
    }

    /**
     * Does the object have a property that starts with the given value?
     *
     * @param {*} obj
     * @param {string} val
     */
    static hasPropertyStartingWith(obj, val) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                if (prop.startsWith(val)) {
                    return true;
                }
            }
        }
        return false;
    }

}
